import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CustomerAccount } from '@dch/common-business-logic';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BillingCustomerService } from 'src/app/my-bill/services/billing-customer.service';

import {
  getCustomerAccountFailure,
  getCustomerAccountRequest,
  getCustomerAccountSuccess,
} from '../actions/customer.actions';

@Injectable()
export class CustomerAccountEffects {
  getCustomerAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getCustomerAccountRequest),
      switchMap(() =>
        this.customerService
          // BUPA-7725 In the android webview there is a delay before the
          // isMyproximusMobileApp value is set
          // so we cannot use this.environmentService.isMyProximusMobileApp
          // or this.environmentService.isMillenialsMobileApp in this scenario
          // this is why here we always fetch the user data from the
          // uService cache with getCustomerAccount(false)
          .getCustomerAccount()
          .pipe(
            map((customerAccount: CustomerAccount) =>
              getCustomerAccountSuccess({
                customerAccount,
              })
            ),
            catchError(() => of(getCustomerAccountFailure()))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private customerService: BillingCustomerService
  ) {}
}
